const getConfigDetails = Object.freeze({
    ENV: process.env.REACT_APP_ENV || 'development',

    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,

    FACILITY_ID: Number(process.env.REACT_APP_FACILITY_ID),

    FULL_SEASON: process.env.REACT_APP_FULL_SEASON,
    HALF_SEASON: process.env.REACT_APP_HALF_SEASON,
    SIX_PACK: process.env.REACT_APP_SIX_PACK,

    PARTNER_ID: process.env.REACT_APP_PARTNER_ID,
    CLIENT_ID: process.env.REACT_APP_CLIENT_ID,

    // avoid using directly in API calls
    CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET,
    GLOBAL_CLIENT_SECRET: process.env.REACT_APP_GLOBAL_CLIENT_SECRET,
})

export default getConfigDetails